/* unplugin-vue-components disabled */import { render } from "./Unfolding3DRender.vue?vue&type=template&id=7ba42028&scoped=true"
import script from "./Unfolding3DRender.vue?vue&type=script&lang=js"
export * from "./Unfolding3DRender.vue?vue&type=script&lang=js"

import "./Unfolding3DRender.vue?vue&type=style&index=0&id=7ba42028&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ba42028"]])

export default __exports__